import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/networkHandler';
import { tokenConfig } from '../tokenConfig';

// Fetch campaign by year
export const getCampaignByYear = createAsyncThunk(
  'dashboard/campaign-report',
  async ({year, exportData}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      let params = '';
      if (year) {
        params += `year=${encodeURIComponent(year)}`;
      }
      if (exportData) {
        params += `&exportData=true&exportType=csv`;
      }
      const response = await axios.get(`/dashboard/campaign-report?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch campaign by year Details
export const getCampaignByYearDetails = createAsyncThunk(
  'dashboard/campaign-report-details',
  async ({page, rowsPerPage, name, monthYear, exportData}, { getState, rejectWithValue }) => {
    try {
      if (!monthYear || typeof monthYear !== 'string') {
        throw new Error('Invalid monthYear parameter');
      }
      const config = tokenConfig(getState);
      let params = [];
      if (page !== undefined && rowsPerPage !== undefined) {
        params.push(`page=${page + 1}`, `limit=${rowsPerPage}`);
      }
      if (name) {
        params.push(`name=${encodeURIComponent(name)}`);
      }
      if (exportData) {
        params.push(`exportData=true`, `exportType=csv`);
      }
      //console.log(monthYear)
      const response = await axios.get(`/dashboard/campaign-report-details/${monthYear}?${params.join("&")}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch Chart data
export const getChartData = createAsyncThunk(
    'dashboard/campaign-report-chart',
    async ({startDate, endDate}, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        let params = '';
        if (startDate) {
          params += `startDate=${encodeURIComponent(startDate)}`;
        }
        if (endDate) {
            params += `&endDate=${encodeURIComponent(endDate)}`;
          }
        const response = await axios.get(`/dashboard/campaign-report-chart?${params}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );


  // Fetch Daily campaign
export const getDailyCampaign = createAsyncThunk(
  'dashboard/daily-campaign',
  async ({startDate, endDate, exportData}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      let params = [];
      if (startDate) {
        params.push(`startDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        params.push(`endDate=${encodeURIComponent(endDate)}`);
        }
        if (exportData) {
          params.push(`exportData=true`, `exportType=csv`);
        }
      const response = await axios.get(`/user/daily-campaign?${params.join("&")}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
  


const reportSlice = createSlice({
  name: 'report',
  initialState: {
    loading: false,
    meta: null,
    campaignByYear: [],
    campaignByYearDetails: [],
    dailyCampaign: [],
    chartData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCampaignByYear.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.loading = true;
        state.error = null;
      })
      .addCase(getCampaignByYear.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.loading = false;
        state.campaignByYear = action.payload.data;
      })
      .addCase(getCampaignByYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'An error occurred';
      })
      // Fetch campaign by year details
      builder
       .addCase(getCampaignByYearDetails.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
          state.loading = true;
          state.error = null;
        })
       .addCase(getCampaignByYearDetails.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
          state.loading = false;
          state.campaignByYearDetails = action.payload.data;
          state.meta = action.payload.meta; // Store pagination meta
        })
       .addCase(getCampaignByYearDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload?.message || 'An error occurred';
        });
        // Fetch Chart data
        builder
       .addCase(getChartData.pending, (state) => {
         state.loading = true;
          state.error = null;
        })
       .addCase(getChartData.fulfilled, (state, action) => {
         state.loading = false;
          state.chartData = action.payload.data;
        })
       .addCase(getChartData.rejected, (state, action) => {
         state.loading = false;
          state.error = action.payload?.message || 'An error occurred';
        })
        // Fetch daily campaign
        builder
       .addCase(getDailyCampaign.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
         state.loading = true;
          state.error = null;
        })
       .addCase(getDailyCampaign.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
         state.loading = false;
          state.dailyCampaign = action.payload.data;
        })
       .addCase(getDailyCampaign.rejected, (state, action) => {
         state.loading = false;
          state.error = action.payload?.message || 'An error occurred';
        })
  },
});

export default reportSlice.reducer;
